import { merge } from '../../helper';

import * as exElement from '../../utils/element';

// ----------------------------------------------------------------------------

type TypeValidationConfig = {
    merge?: any;
    type?: string;
    valid?: Record<string, any> | string;
    invalid?: Record<string, any> | string;
};

// ----------------------------------------------------------------------------

function create(config: TypeValidationConfig = {}): Record<string, any> {
    // Default Config
    const defConfig: TypeValidationConfig = {
        type: 'feedback',
    };

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    //
    const elements: Record<string, any> = {
        list: [],
    };

    // If using valid
    if (defConfig.valid != null) {
        // If valid is string
        if (typeof defConfig.valid === 'string') {
            defConfig.valid = {
                html: defConfig.valid,
            };
        }

        const elValid = createValid({
            type: defConfig.type,
            ...defConfig.valid,
        });
        elements.valid = elValid;

        elements.list.push(elValid);
    }

    // If using invalid
    if (defConfig.invalid != null) {
        // If invalid is string
        if (typeof defConfig.invalid === 'string') {
            defConfig.invalid = {
                html: defConfig.invalid,
            };
        }

        // Create element (invalid)
        const elInvalid = createInvalid({
            type: defConfig.type,
            ...defConfig.invalid,
        });
        elements.invalid = elInvalid;

        //
        elements.list.push(elInvalid);
    }

    // ------------------------------------------------------------------------

    // Return
    return elements;
}

function createValid(config: Record<string, any> = {}): HTMLElement {
    // Create element (valid)
    const elValid = exElement.create({
        merge: config,
        class: {
            new: 'valid-' + config.type,
        },
    });

    return elValid;
}

function createInvalid(config: Record<string, any> = {}): HTMLElement {
    // Create element (invalid)
    const elInvalid = exElement.create({
        merge: config,
        class: {
            new: 'invalid-' + config.type,
        },
    });

    return elInvalid;
}

// ----------------------------------------------------------------------------

export { create };
